import { domain } from 'modules/data';

import { videoLinkQBooks, videoLinkXero } from './IntroductionVideo.constants';
import { messages } from './IntroductionVideo.messages';

export const getVideoLink = (integrationType?: domain.IntegrationType) => {
    if (integrationType === domain.IntegrationType.QBooks) {
        return videoLinkQBooks;
    }

    return videoLinkXero;
};

export const getTitle = (integrationType?: domain.IntegrationType) => {
    if (integrationType === domain.IntegrationType.Xero) {
        return messages.titleXero;
    }

    if (integrationType === domain.IntegrationType.QBooks) {
        return messages.titleQbooks;
    }

    return messages.titleOther;
};
